import { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import useUnreadMessages from '../hooks/useUnreadMessages';
import api from '../config/api';

/**
 * GlobalNotificationSubscriber ensures that all user trips are subscribed
 * for real-time notifications regardless of which page is currently active.
 * This prevents notification updates from stopping when navigating between pages.
 */
const GlobalNotificationSubscriber = () => {
  const { user } = useAuth();
  const [allTripIds, setAllTripIds] = useState([]);

  // Subscribe to all user trip IDs for notifications
  useUnreadMessages(allTripIds);

  // Fetch all user trip IDs
  const fetchAllTripIds = useCallback(async () => {
    if (!user) return;

    try {
      const response = await api.get('/trips');
      console.log('🌐 [GlobalNotificationSubscriber] Raw trips data:', response.data);
      
      const tripIds = response.data
        .map(trip => {
          console.log('🌐 [GlobalNotificationSubscriber] Processing trip:', { id: trip.id, title: trip.title, idType: typeof trip.id });
          return trip.id;
        })
        .filter(id => {
          const isValid = id && !isNaN(id) && id !== 'NaN';
          if (!isValid) {
            console.warn('🚫 [GlobalNotificationSubscriber] Filtering out invalid trip ID:', id);
          }
          return isValid;
        });
      setAllTripIds(tripIds);
      console.log('🌐 [GlobalNotificationSubscriber] Subscribed to all trips:', tripIds);
    } catch (error) {
      console.error('Error fetching trips for global notifications:', error);
    }
  }, [user]);

  // Fetch trip IDs when user changes
  useEffect(() => {
    fetchAllTripIds();
  }, [fetchAllTripIds]);

  // Refresh trip IDs periodically (every 5 minutes) to catch new trips
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(fetchAllTripIds, 5 * 60 * 1000); // 5 minutes
    return () => clearInterval(interval);
  }, [user, fetchAllTripIds]);

  // This component doesn't render anything
  return null;
};

export default GlobalNotificationSubscriber;
